export const PROFILES_ROUTES = {
  LIST: '/perfis',
  NEW: '/perfis/novo',
  DETAIL_PATTERN: '/perfis/:id',
  detail: (id: string) => `/perfis/${id}`,
} as const;

export const PROFILES_ENDPOINTS = {
  LIST: '/api/v1/profiles',
  detail: (id: string) => `/api/v1/profiles/${id}`,
} as const;

export const PROFILES_QUERY_KEYS = {
  all: ['profiles'] as const,
  list: (page: number, perPage: number, search: string) =>
    ['profiles', 'list', page, perPage, search] as const,
  detail: (id: string) => ['profiles', 'detail', id] as const,
};
